import API from 'services/api';

export const filters = () => {
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'Region',
        field: 'region',
        type: 'async-select',
        useAsyncInFilters: true,
        fetchOptions: API.fetchRegionList,
        dataTransform: ({ data }) => {
          return data.map(m => ({ id: m.id, name: m.name }));
        },
        fetchFilters: {
          archived: false,
        },
        multiple: false,
        optionLabelKey: 'name',
      },
    ],
  };
};
